import { createContext } from 'react'

// Associates descriptions with the central entry that owns their rendered subtree.
export const DrawerSurfaceEntryContext = createContext<string | undefined>(undefined)
